import React from "react"
import { AppSelectionBar, AppSelectionBarButton } from "@components"
import { isOpenProvidersSuppliersMappingModal, selectedTable } from "Pages/Admin/ProvidersSuppliersMapping/@signals"

export default function MultiProvidersSuppliersMappingTableToolbar({ type, selectedData, setSelectedRows }) {

	return <AppSelectionBar count={selectedData?.length || 0} onClear={() => setSelectedRows([])}>
		<AppSelectionBarButton
			icon="pen"
			label="Edit mappings"
			title="Edit selected mappings"
			onClick={() => {
				isOpenProvidersSuppliersMappingModal.value = selectedData
				selectedTable.value = type
				setSelectedRows([])
			}}
		/>
	</AppSelectionBar>
}